define("shared/utils/is-popup-window", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.isPopupWindow = isPopupWindow;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Check that the current `window` context is that of a popup window context.
   * @returns Window context is a popup
   */
  function isPopupWindow() {
    // Note: If `window.opener` exists: In a normal browser window,
    // `window.opener` will be `null`. However, when opened as a
    // popup using `window.open()`, the `opener` property will reference
    // the window that opened the popup.
    return Boolean(window.opener);
  }
  var _default = _exports.default = isPopupWindow;
});